module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlZones", "Zones" ) ))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div data-region="zones-sticky"></div><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div data-region="zones-container"></div><div data-region="zones-inactive"></div></div></div>';
}
return __p;
};
